import React from 'react';
import ChatMessenger from './ChatMessenger';
import './ChatMessenger.css';
import VedSourcerChatPane from '../ved/VedSourcerChatPane';
import type { ChatTab } from '../../context/ChatUiContext';

export default function ChatWorkspace({
  tab = 'analysts',
  initialProductId,
  initialOrderId,
  compact = false,
  onTabChange,
  onSelectOrder
}: {
  tab?: ChatTab;
  initialProductId?: string;
  initialOrderId?: number | null;
  compact?: boolean;
  onTabChange?: (tab: ChatTab) => void;
  onSelectOrder?: (id: number) => void;
}) {
  const active = tab === 'buyers' ? 'buyers' : 'analysts';

  return (
    <div className={`chat-workspace${compact ? ' is-compact' : ''}`}>
      <div className="chat-workspace-tabs" role="tablist">
        <button
          type="button"
          role="tab"
          aria-selected={active === 'analysts'}
          className={`chat-workspace-tab${active === 'analysts' ? ' is-active' : ''}`}
          onClick={() => onTabChange?.('analysts')}
        >
          Аналитики
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={active === 'buyers'}
          className={`chat-workspace-tab${active === 'buyers' ? ' is-active' : ''}`}
          onClick={() => onTabChange?.('buyers')}
        >
          Buyers
        </button>
      </div>
      <div className="chat-workspace-body">
        {active === 'buyers' ? (
          <VedSourcerChatPane
            embedded
            initialOrderId={initialOrderId || null}
            onSelectOrder={onSelectOrder}
          />
        ) : (
          <ChatMessenger
            key={initialProductId || 'no-product'}
            initialProductId={initialProductId}
            compact={compact}
          />
        )}
      </div>
    </div>
  );
}
